import { generateServiceId } from "@core/domains/identity";

export const MEMORY_SERVICE = {
  ID: generateServiceId("memory"),
  JOB_TYPES: { commentSync: "commentSync" },
  LABEL: "memory",
} as const;
